import {FC, useContext, useEffect} from 'react';
import {useRecoilValueLoadable} from 'recoil';
import {PhotoView} from 'react-photo-view';

import {CircularProgress, Stack, Tooltip, Typography} from '@mui/material';

import {EventBusContext} from '../../../../../providers/EventBus';

import {IDocument} from '../../../../../shared/types/document.types';

import {colors} from '../../../../../shared/colors';

import {contentTreePhotoQueryFamily} from '../../../../../store/service-requests/selectors';

import splash from '../../../../../assets/Subtract.jpg';

interface IDelayImage {
  photo: IDocument | File | null;
  label: string;
}

export const DelayImage: FC<IDelayImage> = ({photo, label}) => {
  const {contents, state} = useRecoilValueLoadable(
    contentTreePhotoQueryFamily(photo && 'id' in photo ? photo?.id : null),
  );
  const {bus} = useContext(EventBusContext);

  useEffect(() => {
    state === 'hasError' && bus?.emit('error', [contents, {toastId: 'DelayImageQuery'}]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return state === 'loading' ? (
    <Stack sx={{height: '50px', width: '50px', alignItems: 'center', justifyContent: 'center'}}>
      <CircularProgress size="small" sx={{height: '22px', width: '22px'}} />
    </Stack>
  ) : state === 'hasValue' && typeof contents === 'string' ? (
    <PhotoView
      overlay={
        <Typography color="#fff" variant="h6">
          {label}
        </Typography>
      }
      src={state === 'hasValue' && typeof contents === 'string' ? contents : splash}
    >
      <img style={{height: '50px', width: '50px', cursor: 'pointer'}} src={contents} alt="" />
    </PhotoView>
  ) : photo instanceof File ? (
    <PhotoView
      overlay={
        <Typography color="#fff" variant="h6">
          {label}
        </Typography>
      }
      src={URL.createObjectURL(photo)}
    >
      <img style={{height: '50px', width: '50px', cursor: 'pointer'}} src={URL.createObjectURL(photo)} alt="" />
    </PhotoView>
  ) : !photo ? null : (
    <Tooltip PopperProps={{disablePortal: true}} title="Ошибка загрузки">
      <img
        style={{height: '49px', width: '49px', border: `1px solid ${colors['red']}`}}
        src={splash}
        alt="Ошибка загрузки"
      />
    </Tooltip>
  );
};
